import Button from "@components/ui/button";
import { toast } from "react-toastify";

interface IProps {
  msg?: string;
  onRetry?: () => void;
}

export const sendMediaLibErrorToast = ({
  msg = "Something went wrong, try again",
  onRetry,
}: IProps = {}) => {
  toast.error(msg, {
    className: "images-panel-clickable",
    closeButton: onRetry
      ? ({ closeToast }) => (
          <Button
            variant="secondary"
            size="xs"
            className="images-panel-clickable tw-my-auto tw-ml-4"
            onClick={(e) => {
              closeToast(e);
              onRetry();
            }}
          >
            Try again
          </Button>
        )
      : undefined,
  });
};
